import {Link} from 'react-router-dom';
import {
  SoopLayer,
  SoopLayerHeader,
  SoopLayerContent,
  useDialogContext,
} from '@soop-ui/soop-ui';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {sendHelpClickLog} from '@/utils/help/log';
import styles from './ReportSelectLayer.module.scss';

const ReportSelectLayer = () => {
  const {close} = useDialogContext();
  const handleClose = () => {
    close(false);
  };

  const handleReportClick = (
    actionType:
      | typeof HELP_LOG.ACTION_TYPE.TO_CONTENT
      | typeof HELP_LOG.ACTION_TYPE.TO_ILLEGAL_VIDEO,
  ) => {
    handleClose();
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_BANNER, {
      buttonType: HELP_LOG.BUTTON_TYPE.CS_REPORT,
      actionType,
    });
  };

  return (
    <SoopLayer onClose={handleClose} size='lg'>
      <SoopLayerHeader align='center'>신고하기</SoopLayerHeader>
      <SoopLayerContent>
        SOOP 서비스 이용 약관 및 운영정책에 따라 처리되고 있습니다.
        <div className={styles.SelectWrapper}>
          <ul className={styles.SelectList}>
            <li className={styles.ReportContentList}>
              <Link
                className={styles.ReportContentBox}
                to={ROUTE.HELP.REPORT_CONTENT}
                onClick={() =>
                  handleReportClick(HELP_LOG.ACTION_TYPE.TO_CONTENT)
                }>
                <span>콘텐츠 신고</span>
                <p>
                  부적절한 방송 및 게시글, 스트리머를
                  <br />
                  제보해 주세요.
                </p>
              </Link>
            </li>
            <li className={styles.ReportIllegalList}>
              <Link
                className={styles.ReportContentBox}
                to={ROUTE.HELP.REPORT_ILLEGAL}
                onClick={() =>
                  handleReportClick(HELP_LOG.ACTION_TYPE.TO_ILLEGAL_VIDEO)
                }>
                <span>불법촬영물등 유통 신고</span>
                <p>
                  불법촬영물등이 유통되는 것을 <br />
                  신고해 주세요
                </p>
              </Link>
            </li>
          </ul>
        </div>
      </SoopLayerContent>
    </SoopLayer>
  );
};
export default ReportSelectLayer;
